
import { CommandModel } from "@/app/entities";
import {
  DashboardHeader,
  SideImageCard,
  UiBadge,
  UiButton,
} from "@/components";
import DashboardLayout from "@/components/layouts/dashboard-layout";
import { useCommande } from "@/composables/commande";
import { ArrowLeft, Edit, Goal } from "lucide-react";
import { useParams, useNavigate } from "react-router-dom";
import { ReactElement, useEffect, useState } from "react";

interface RowInformationProps {
  label: string;
  value: string | number | React.ReactNode;
  labelIcon?: React.ReactNode;
  className?: string;
}
function RowInformation({
  label,
  value,
  labelIcon,
  className,
}: RowInformationProps) {
  return (
    <div
      className={`flex gap-8 items-center p-1 border-b  justify-between ${
        className || ""
      }`}
    >
      <label className="ui-form-label flex gap-2 items-center mb-1">
        {labelIcon}
        {label}
      </label>
      <div className="text-xs font-semibold">{value}</div>
    </div>
  );
}

export default function DashboardCommandeDetail() {
  const { reference } = useParams<{ reference: string }>();
  const navigate = useNavigate();
  const { getCommandeByReference, getCommandeStatusBadgeCode } = useCommande();
  const [commande, setCommande] = useState<CommandModel | undefined>(undefined);

  useEffect(() => {
    if (reference) {
      setCommande(getCommandeByReference(reference));
    }
  }, [reference]);

  const statusLabel = commande?.statut;

  return (
    <div>
      <DashboardHeader subTitle="Bienvenue aux campagnes" />

      <div className="py-4">
        <SideImageCard imgSrc="/assets/images/chris-lee-70l1tDAI6rM-unsplash 1.png">
          <div className="">
            <UiButton
              variant="text"
              onClick={() => navigate(-1)}
              startIcon={<ArrowLeft />}
            >
              Retour
            </UiButton>
          </div>

          <div className="p-4  w-full">
            <h1 className="text-2xl pb-4 form-title">
              Campagne : {commande?.campagne?.nom ?? ""}
            </h1>

            <label className="ui-form-label flex gap-2 items-center mb-1">
              <Goal width={16} height={16} />
              Objectif de la campagne
            </label>
            <div className="p-2 border border-gray-200 rounded-md mb-4">
              {commande?.campagne?.objectif ?? ""}
            </div>

            <RowInformation
              label="Réference"
              value={commande?.reference ?? ""}
            />
            <RowInformation
              label="Auteur"
              value={`${commande?.auteur?.nom ?? ""} ${
                commande?.auteur?.prenom ?? ""
              }`}
            />

            <RowInformation
              label="Ville de Livraison"
              value={commande?.villeLivraison ?? ""}
            />
            <RowInformation
              label="Détail adresse"
              value={commande?.detailAdresse ?? ""}
            />

            <RowInformation
              label="Fournisseur"
              value={`${commande?.fournisseur?.nom ?? ""} ${
                commande?.fournisseur?.prenom ?? ""
              }`}
            />

            <RowInformation
              label="Date de fabrication souhaitée"
              value={commande?.dfs ?? ""}
            />
            <RowInformation
              label="Date de création"
              value={commande?.dateCreation ?? ""}
            />
            <RowInformation
              label="Date de modification"
              value={commande?.ddm ?? ""}
            />

            <RowInformation
              label="Statut"
              value={
                <UiBadge variant={getCommandeStatusBadgeCode(commande)}>
                  {statusLabel}
                </UiBadge>
              }
              className="my-2 py-2"
            />

            <RowInformation
              label="Commentaire"
              value={commande?.commentaire ?? ""}
            />

            <div className="flex gap-2 flex-wrap justify-end items-center mt-8">
              <UiButton
                size="small"
                className="flex gap-2 items-center"
                onClick={() =>
                  navigate(
                    `/dashboard/commandes/edit/${commande?.reference ?? ""}`
                  )
                }
              >
                <Edit /> Modifier
              </UiButton>
            </div>
          </div>
        </SideImageCard>
      </div>
    </div>
  );
}
